import React from 'react';
import { Link } from 'react-router-dom';

const Properties = () => {
    return (
        <div className="container section text-center">
            <h1>Available Properties</h1>
            <p style={{ margin: '2rem 0', color: 'var(--color-grey)' }}>
                We are currently updating our property listings. Please check back soon or contact us for availability.
            </p>
            <Link to="/contact" className="btn-primary">Contact for Availability</Link>
        </div>
    );
};

export default Properties;
